import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

const isRecoveryFlow =
  window.location.pathname === "/reset-password" &&
  window.location.hash.includes("access_token");

if (!isRecoveryFlow && window.location.hash && window.location.hash.includes("access_token")) {
  setTimeout(() => {
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
  }, 500);
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const ph = document.getElementById("lcp-placeholder");
    if (ph) {
      ph.style.cssText += ";opacity:0;transition:opacity 0.3s;pointer-events:none;";
      setTimeout(() => { ph.remove(); }, 350);
    }
  });
});
